class ajaxCart extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#ajaxcart-overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#ajax-cart-icon');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.cart-inner-empty') : document.getElementById('ajaxcart');
      const focusElement = this.querySelector('.drawer-inner');
      triggerClick(containerToTrapFocusOn, focusElement);
    }, { once: true });
    
  }
  close() {
    this.classList.remove('active');
    triggerClickClose(this.activeElement);
    
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    cartDrawerNote.parentElement.addEventListener('keyup', escClick);
  }
  renderContents(parsedState) {
    this.querySelector('.drawer-inner').classList.contains('is-empty') && this.querySelector('.drawer-inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.fetchSecToInclude().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.callSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    setTimeout(() => {
      this.querySelector('#ajaxcart-overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }
  callSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  fetchSecToInclude() {
    return [
      {
        id: 'ajax-cart',
        selector: '#ajaxcart'
      },
      {
        id: 'ajax-cart-icon'
      }
    ];
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('ajax-cart', ajaxCart);
class ajaxCartPro extends CartProduct {
  fetchSecToInclude() {
    return [
      {
        id: 'ajaxcart',
        section: 'ajax-cart',
        selector: '.drawer-inner'
      },
      {
        id: 'ajax-cart-icon',
        section: 'ajax-cart-icon',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-pro', ajaxCartPro);
/* ===== H&H Drawer Enhancer ===== */
(function(){
  const USD = true;                 // valuta (USD)
  const FREE_SHIP = 60;             // free shipping drempel in USD
  const DRAWER_SEL = '#CartDrawer, .ajax-cart, .cart-drawer, .drawer--cart'; // mogelijke containers

  function fmtUSD(cents){
    const v = (cents/100);
    try { return new Intl.NumberFormat(undefined,{style:'currency',currency: USD?'USD':'EUR'}).format(v); }
    catch(e){ return (USD?'$':'€')+v.toFixed(2); }
  }

  function getDrawerEl(){
    return document.querySelector(DRAWER_SEL);
  }

  function injectEnhancerOnce(){
    const drawer = getDrawerEl();
    if(!drawer) return false;
    if (drawer.querySelector('#hh-cart-drawer-enhancer')) return true;

    const tpl = document.getElementById('hh-cart-drawer-enhancer-template');
    if(!tpl) return false;

    const node = tpl.content ? tpl.content.cloneNode(true) : null;
    if(!node) return false;

    // Plaats onderaan de drawer
    drawer.appendChild(node);
    initEnhancer();
    return true;
  }

  function startTimer(seconds=600){
    const el = document.getElementById('hhcd-timer');
    if(!el) return;
    let t = seconds;
    const tick=()=>{
      const m = String(Math.floor(t/60)).padStart(2,'0');
      const s = String(t%60).padStart(2,'0');
      el.textContent = `${m}:${s}`;
      if(t>0){ t--; setTimeout(tick,1000); }
    };
    tick();
  }

  function initEnhancer(){
    // Timer (soft urgency)
    startTimer(600);

    // Free shipping progress + upsells
    fetch('/cart.js')
      .then(r=>r.json())
      .then(cart=>{
        // Progress
        const subtotal = cart.items_subtotal_price || 0;
        const remain = Math.max(0, FREE_SHIP*100 - subtotal);
        const percent = Math.min(100, Math.round((subtotal/(FREE_SHIP*100))*100));
        const bar = document.getElementById('hhcd-bar');
        const sub = document.getElementById('hhcd-subtotal');
        const msg = document.getElementById('hhcd-msg');
        if(bar) bar.style.width = percent + '%';
        if(sub) sub.textContent = fmtUSD(subtotal);
        if(msg) msg.textContent = remain>0 ? `Spend ${fmtUSD(remain)} more to unlock FREE shipping.` : `You’ve unlocked FREE shipping!`;

        // Upsells (gebaseerd op eerste cart item)
        const grid = document.getElementById('hhcd-upsell-grid');
        if(grid && cart.items && cart.items.length){
          const firstId = cart.items[0].product_id;
          fetch(`/recommendations/products.json?product_id=${firstId}&limit=4`)
            .then(r=>r.json())
            .then(data=>{
              if(!data || !data.products) return;
              grid.innerHTML = data.products.map(p=>{
                const v = (p.variants||[])[0];
                const priceCents = p.price || (v && v.price) || 0;
                const img = (p.images && (p.images[0]?.src || p.images[0]?.url)) || (p.featured_image && (p.featured_image.src || p.featured_image.url)) || '';
                const thumb = img ? img.replace('.png','_400x.png').replace('.jpg','_400x.jpg').replace('.jpeg','_400x.jpeg') : '';
                return `
                  <div class="hhcd-upsell-card">
                    <img class="hhcd-upsell-img" src="${thumb}" alt="${p.title||''}">
                    <div class="hhcd-upsell-body">
                      <div class="hhcd-upsell-title">${p.title||''}</div>
                      <div class="hhcd-upsell-price">${fmtUSD(priceCents)}</div>
                      ${v ? `<button class="hhcd-btn" data-vid="${v.id}">Add</button>` : ''}
                    </div>
                  </div>
                `;
              }).join('');

              // AJAX add
              grid.addEventListener('click', e=>{
                const btn = e.target.closest('.hhcd-btn');
                if(!btn) return;
                const id = btn.getAttribute('data-vid');
                btn.disabled = true;
                fetch('/cart/add.js',{method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id, quantity:1})})
                  .then(r=>r.json())
                  .then(()=>{ btn.textContent = 'Added ✓'; setTimeout(()=>{ btn.disabled=false; btn.textContent='Add'; /* refresh drawer */ fetch('/cart.js').then(r=>r.json()).then(()=>injectEnhancerOnce()); }, 800); })
                  .catch(()=>{ btn.disabled=false; });
              });
            })
            .catch(()=>{});
        }
      })
      .catch(()=>{});
  }

  // 1) Probeer direct bij pageload
  document.addEventListener('DOMContentLoaded', injectEnhancerOnce);

  // 2) Observeer mutations (drawer wordt dynamisch vervangen door ajax-cart.js)
  const obs = new MutationObserver(()=> injectEnhancerOnce());
  obs.observe(document.documentElement, {childList:true, subtree:true});

  // 3) Hook op klikken die drawer openen (meest voorkomende selectors)
  ['[href*="/cart"]','.cart-icon','.header-cart','.js-cart-toggle'].forEach(sel=>{
    document.addEventListener('click', e=>{
      if(e.target.closest(sel)) setTimeout(injectEnhancerOnce, 400);
    });
  });
})();